import {auth} from "../../firebase/firebase-config";
import {updatePassword, User} from "@firebase/auth";
import {toAccountsError} from "../../firebase/errors";
import {useState} from "react";
import {waitAtLeast} from "../../test/test-util";
import {reauthenticate} from "./reauthenticate";
import {translateKey} from "../language/translate";

type ChangePasswordSubmitFn = (oldPassword: string, newPassword: string) => Promise<void>

export type UseChangePasswordReturn = {
  isSubmitting: boolean;
  isSuccess: boolean;
  clearSuccess: () => void;
  changePassword?: ChangePasswordSubmitFn;
}

export const useChangePassword = (minLoadingTime = 500): UseChangePasswordReturn => {
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  let changePassword = undefined;
  if (auth.currentUser) {
    changePassword = async (oldPassword: string, newPassword: string) => {
      const user = auth.currentUser;
      if (!user) {
        throw new Error(translateKey("account:validation.userNotSignedIn"));
      }
      setSubmitting(true);
      await waitAtLeast(doUpdatePassword(user, oldPassword, newPassword), minLoadingTime).
        then(() => setIsSuccess(true)).finally(() => setSubmitting(false));
    }
  }
  return {
    changePassword,
    isSubmitting,
    isSuccess,
    clearSuccess: () => setIsSuccess(false)
  };
};

const doUpdatePassword = async (user: User, oldPassword: string, newPassword: string) => {
  return reauthenticate(user, oldPassword).then(() => updatePassword(user, newPassword)).
    then(() => reauthenticate(user, newPassword)).
    catch(err => Promise.reject(toAccountsError(err, "invalidUsernameOrPassword")));
};
